import { NgModule } from '@angular/core';
import { BaseInputComponent } from './element/base-input/base-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from 'ng2-file-upload';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TextMaskModule } from 'angular2-text-mask';

import { BaseTextareaComponent } from './element/base-textarea/base-textarea.component';
import { BaseInputMaskComponent } from './element/base-input-mask/base-input-mask.component';
import { BaseSelectComponent } from './element/base-select/base-select.component';
import { BaseSelectRemoteComponent } from './element/base-select-remote/base-select-remote.component';
import { HintComponent } from './element/common/hint/hint.component';
import { ColorpickerComponent } from './element/colorpicker/colorpicker.component';
import { UploadComponent } from './element/upload/upload.component';
import { UploadBrowseComponent } from './element/upload-browse/upload-browse.component';
import { UiModule } from '../ui/ui.module';
import { BaseCheckboxComponent } from './element/base-checkbox/base-checkbox.component';
import { BaseRadioComponent } from './element/base-radio/base-radio.component';
import { BaseRadioGroupComponent } from './element/base-radio-group/base-radio-group.component';
import { MultiUploadComponent } from './element/multi-upload/multi-upload.component';
import { JobModule } from '../../module/job/job.module';
import { DatepickerComponent } from './element/datepicker/datepicker.component';
import { FontpickerComponent } from './element/fontpicker/fontpicker.component';
import { MultilangInputComponent } from './element/multilang-input/multilang-input.component';
import { TextadjustmentpickerComponent } from './element/textadjustmentpicker/textadjustmentpicker.component';
import { LanguagepickerComponent } from './element/languagepicker/languagepicker.component';
import { SingleCheckboxComponent } from './element/standalone/single-checkbox/single-checkbox.component';
import { BaseCheckboxGroupComponent } from './element/base-checkbox-group/base-checkbox-group.component';
import { BaseInputPrependComponent } from './element/base-input-prepend/base-input-prepend.component';
import { BaseInputPasswordComponent } from './element/base-input-password/base-input-password.component';
import { SwitcherComponent } from './element/switcher/switcher.component';
import { NgxMaskModule } from 'ngx-mask';
import { SingleSwitcherComponent } from './element/standalone/switcher/switcher.component';
import { ToggleSwitchComponent } from './element/toggle-switch/toggle-switch.component';
import { TimezonePickerComponent } from './element/timezone-picker/timezone-picker.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { IndirectUploadZoneComponent } from './element/indirect-upload-zone/indirect-upload-zone.component';

@NgModule({
    declarations: [
        BaseInputComponent,
        BaseSelectComponent,
        BaseTextareaComponent,
        BaseInputMaskComponent,
        BaseSelectRemoteComponent,
        BaseCheckboxComponent,
        BaseRadioComponent,
        BaseRadioGroupComponent,
        BaseCheckboxGroupComponent,
        DatepickerComponent,
        HintComponent,
        ColorpickerComponent,
        TextadjustmentpickerComponent,
        LanguagepickerComponent,
        MultiUploadComponent,
        UploadComponent,
        UploadBrowseComponent,
        FontpickerComponent,
        MultilangInputComponent,
        IndirectUploadZoneComponent,
        BaseInputPrependComponent,
        BaseInputPasswordComponent,
        SwitcherComponent,
        TimezonePickerComponent,
        // standalone
        SingleCheckboxComponent,
        SingleSwitcherComponent,

        ToggleSwitchComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TextMaskModule,
        FileUploadModule,
        ProgressbarModule,
        UiModule,
        JobModule,
        NgxMaskModule,
        NgSelectModule,
    ],
    exports: [
        FileUploadModule,
        BaseInputComponent,
        BaseTextareaComponent,
        BaseInputMaskComponent,
        BaseSelectComponent,
        BaseCheckboxGroupComponent,
        BaseSelectRemoteComponent,
        BaseCheckboxComponent,
        BaseInputPasswordComponent,
        BaseRadioComponent,
        BaseRadioGroupComponent,
        MultiUploadComponent,
        HintComponent,
        ColorpickerComponent,
        TextadjustmentpickerComponent,
        LanguagepickerComponent,
        DatepickerComponent,
        UploadComponent,
        UploadBrowseComponent,
        FontpickerComponent,
        MultilangInputComponent,
        IndirectUploadZoneComponent,
        BaseInputPrependComponent,
        SwitcherComponent,
        TimezonePickerComponent,

        // standalone
        SingleCheckboxComponent,
        SingleSwitcherComponent,

        ToggleSwitchComponent,
    ],
    providers: [],
})
export class FormModule {}
